export enum LookCardSizes {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small'
}
